import { v4 as Uuidv4 } from 'uuid'

const useHelpers = () => {
    const config = useRuntimeConfig()

    const timeout = (ms) => {
        return ms ? ms : 5000
    }

    const capitalize = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    }

    const uppercase = (text) => {
        return text.toUpperCase()
    }

    const lowercase = (text) => {
        return text.toLowerCase()
    }

    const titleCase = (string) => {
        return string
            .toLowerCase()
            .split(' ')
            .map(function (text) {
                return text.replace(text[0], text[0].toUpperCase()).replace(/-/g, ' ')
            })
            .join(' ')
    }

    const phoneNumberRemoveSpaces = (phoneNumber) => {
        return phoneNumber.replace(/\s/g, '')
    }

    const phoneNumberRemoveHyphens = (phoneNumber) => {
        return phoneNumber.replace(/-/g, ' ')
    }

    const verificationCode = () => {
        let code = ''
        code += Math.floor(100000 + Math.random() * 900000)

        return code
    }

    const hashedPhoneNumber = (number) => {
        return number.substring(0, 3, number.length - 5) + '*********' + number.substring(11, number.length - 0)
    }

    const generateToken = (length) => {
        let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        let token = ''

        for (let i = 0; i < length; i++) {
            token += chars[Math.floor(Math.random() * chars.length)]
        }

        return token
    }

    const generatePassword = (length) => {
        let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()'
        let password = ''

        for (let i = 0; i < length; i++) {
            password += chars[Math.floor(Math.random() * chars.length)]
        }

        return password
    }

    const generateGuid = () => {
        return Uuidv4()
    }

    const generateOrderNumber = () => {
        let orderNumber = 'TP-'
        orderNumber += Math.floor(1000000000 + Math.random() * 9000000000)

        return orderNumber
    }

    const formatCurrency = (balance, currency) => {
        const amount = balance / 100

        return amount.toLocaleString('en-GB', {
            style: 'currency',
            currency: `${currency}` || 'gbp'
        })
    }

    const formatDateSmall = (date) => {
        const newDate = new Date(date)
        const formatDate = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        })

        return formatDate.format(newDate)
    }

    const formatDate = (date) => {
        const newDate = new Date(date)
        const formatDate = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            weekday: 'long'
        })

        return formatDate.format(newDate)
    }

    const formatTime = (date) => {
        const newDate = new Date(date)
        const formatDate = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit'
            // second: '2-digit'
        })

        return formatDate.format(newDate)
    }

    const formatDateTime = (date) => {
        const newDate = new Date(date)
        const formatDate = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            weekday: 'long',
            hour: '2-digit',
            minute: '2-digit'
            // second: '2-digit'
        })

        return formatDate.format(newDate)
    }

    const formatCalendarDateTime = (date) => {
        const newDate = new Date(date)
        const formatDate = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        })
            .format(newDate)
            .replace(/\//g, '-')
            .replace(/\,/g, '')
            .split('-')
            .reverse()
            .join('-')

        const formatTime = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(newDate)

        return `${formatDate} ${formatTime}`
    }

    const formatOriginalPrice = (price, discount) => {
        return price + price * discount
    }

    const formatDiscountPrice = (price, discount) => {
        return price - price * discount
    }

    const formatPaymentPrice = (price) => {
        return Number(Math.round(price * 100))
    }

    return {
        timeout,
        capitalize,
        uppercase,
        lowercase,
        titleCase,
        phoneNumberRemoveSpaces,
        phoneNumberRemoveHyphens,
        verificationCode,
        hashedPhoneNumber,
        generateToken,
        generatePassword,
        generateGuid,
        generateOrderNumber,
        formatCurrency,
        formatDateSmall,
        formatDate,
        formatTime,
        formatDateTime,
        formatCalendarDateTime,
        formatOriginalPrice,
        formatDiscountPrice,
        formatPaymentPrice
    }
}

export default useHelpers
